import { SessionKit } from '@wharfkit/session'
import WebRenderer from '@wharfkit/web-renderer'
import { WalletPluginAnchor } from '@wharfkit/wallet-plugin-anchor'
import { WalletPluginWombat } from '@wharfkit/wallet-plugin-wombat';
import { WalletPluginTokenPocket } from '@wharfkit/wallet-plugin-tokenpocket';
import { TransactPluginResourceProvider } from '@wharfkit/transact-plugin-resource-provider';

import { DEFAULT_BLOCKCHAIN } from '../config';

const options = {
    transactPlugins: [new TransactPluginResourceProvider()]
};

const sessionKit = new SessionKit({
    appName: 'Create a Token',
    chains: [DEFAULT_BLOCKCHAIN],
    ui: new WebRenderer({minimal: true}),
    walletPlugins: [
        new WalletPluginAnchor(),
        new WalletPluginWombat(),
        new WalletPluginTokenPocket()
    ]
}, options);

export default sessionKit;
